var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
var cls = classNames('form-field-markdown-editor');
import SimpleMDE from "react-simplemde-editor";
import { IconLabel } from './icon-label';
import { useDialogs } from '../hooks/use-dialogs';
import { useLang } from '../hooks/use-lang';
import "easymde/dist/easymde.min.css";
export var FormFieldMarkdownEditorDefaultProps = {
  variant: 'border',
  options: {
    previewClass: ['editor-preview'],
    indentWithTabs: false,
    minHeight: '150px',
    spellChecker: false
  }
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: relative;\n\n    \n    .icon {\n      font-size: 18px;\n      position: relative;\n      top: 3px;\n    }\n\n    .CodeMirror-fullscreen {\n      z-index: 500 !important;\n    }\n\n    ", "\n\n    .CodeMirror-wrap {\n      font-size: 15px;\n      transition: outline-color 0.3s;\n      outline: 1px solid transparent;\n    }\n\n    &:focus-within {\n      .CodeMirror {\n        overflow: visible;\n        clip-path: none !important;\n      }\n      .EasyMDEContainer {\n        .editor-statusbar {\n          outline-color: ", ";\n        }\n      }\n      .CodeMirror-wrap {\n        outline-color: ", ";\n      }\n\n    }\n    .editor-statusbar {\n      outline: 1px solid transparent;\n      transition: outline-color 0.3s;\n      border: 1px solid ", ";\n      border-top: none;\n      background: ", ";\n      border-radius: 0.5px 0.5px 8px 8px !important;\n    }\n\n    .editor-preview-side {\n      z-index: 200;\n      border-right: none;\n      border-left-color: ", ";\n      border-top-color: ", ";\n    }\n\n    .editor-toolbar.fullscreen {\n      z-index: 200;\n      padding: ", " ", " 0 ", ";\n      background: ", ";\n    }\n\n    .editor-toolbar {\n      border: none;\n      padding: 0;\n      margin-bottom: 4px;\n      &:before {\n        margin-bottom: 0px;\n        height: 0;\n      }\n\n      button {\n        border-radius: 0;\n      }\n      \n      button.active,\n      button.hover,\n      button:focus,\n      button:active { \n        border-color: ", ";\n        outline-color: ", ";\n      }\n\n      &.disabled-for-preview {\n        button {\n          opacity: 0.1;\n        }\n\n        button.preview, button.guide {\n          opacity: 1.0;\n        }\n      }\n    }\n\n    .editor-preview {\n      padding: 14px;\n      line-height: 1.5em;\n      a {\n        color: ", ";\n        font-weight: 400;\n        text-decoration: none;\n      }\n\n      h1, h2, h3, h4, h5 {\n        margin-top: 0em;\n        margin-bottom: 0.5em;\n        line-height: 1.35em;\n        font-weight: 500;\n        color: ", ";\n      }\n\n      h1 {\n        font-size: 1.5em;\n      }\n\n      h2 {\n        font-size: 1.3em;\n      }\n\n      h3 {\n        font-size: 1.1em;\n      }\n\n    }\n\n    pre.CodeMirror-line {\n      line-height: 1.5em !important; \n    }\n\n    .CodeMirror-scroll {\n      max-height: 500px;\n      overflow-y: auto;\n    }\n\n    .CodeMirror-fullscreen {\n      .CodeMirror-scroll {\n        max-height: calc(100vh - 54px);\n      }\n    }\n\n    .CodeMirror {\n      border-color: ", ";\n      border-radius: 8px 8px 0 0 !important;\n      border-bottom: none !important;\n      line-height: 1.5em;\n\n      .cm-header {\n        margin-bottom: 0.5em;\n        display: inline-block;\n        line-height: 1.35em;\n        font-weight: 500;\n        color: ", ";\n      }\n\n      .cm-header-1,\n      .cm-header-2,\n      .cm-header-3 {\n      }\n\n      .cm-header-1 {\n        font-size: 1.5em;\n      }\n\n      .cm-header-2 {\n        font-size: 1.3em;\n      }\n\n      .cm-header-3 {\n        font-size: 1.1em;\n      }\n\n      img {\n        max-width: 100%;\n      }\n    }\n  "], ["\n    position: relative;\n\n    \n    .icon {\n      font-size: 18px;\n      position: relative;\n      top: 3px;\n    }\n\n    .CodeMirror-fullscreen {\n      z-index: 500 !important;\n    }\n\n    ", "\n\n    .CodeMirror-wrap {\n      font-size: 15px;\n      transition: outline-color 0.3s;\n      outline: 1px solid transparent;\n    }\n\n    &:focus-within {\n      .CodeMirror {\n        overflow: visible;\n        clip-path: none !important;\n      }\n      .EasyMDEContainer {\n        .editor-statusbar {\n          outline-color: ", ";\n        }\n      }\n      .CodeMirror-wrap {\n        outline-color: ", ";\n      }\n\n    }\n    .editor-statusbar {\n      outline: 1px solid transparent;\n      transition: outline-color 0.3s;\n      border: 1px solid ", ";\n      border-top: none;\n      background: ", ";\n      border-radius: 0.5px 0.5px 8px 8px !important;\n    }\n\n    .editor-preview-side {\n      z-index: 200;\n      border-right: none;\n      border-left-color: ", ";\n      border-top-color: ", ";\n    }\n\n    .editor-toolbar.fullscreen {\n      z-index: 200;\n      padding: ", " ", " 0 ", ";\n      background: ", ";\n    }\n\n    .editor-toolbar {\n      border: none;\n      padding: 0;\n      margin-bottom: 4px;\n      &:before {\n        margin-bottom: 0px;\n        height: 0;\n      }\n\n      button {\n        border-radius: 0;\n      }\n      \n      button.active,\n      button.hover,\n      button:focus,\n      button:active { \n        border-color: ", ";\n        outline-color: ", ";\n      }\n\n      &.disabled-for-preview {\n        button {\n          opacity: 0.1;\n        }\n\n        button.preview, button.guide {\n          opacity: 1.0;\n        }\n      }\n    }\n\n    .editor-preview {\n      padding: 14px;\n      line-height: 1.5em;\n      a {\n        color: ", ";\n        font-weight: 400;\n        text-decoration: none;\n      }\n\n      h1, h2, h3, h4, h5 {\n        margin-top: 0em;\n        margin-bottom: 0.5em;\n        line-height: 1.35em;\n        font-weight: 500;\n        color: ", ";\n      }\n\n      h1 {\n        font-size: 1.5em;\n      }\n\n      h2 {\n        font-size: 1.3em;\n      }\n\n      h3 {\n        font-size: 1.1em;\n      }\n\n    }\n\n    pre.CodeMirror-line {\n      line-height: 1.5em !important; \n    }\n\n    .CodeMirror-scroll {\n      max-height: 500px;\n      overflow-y: auto;\n    }\n\n    .CodeMirror-fullscreen {\n      .CodeMirror-scroll {\n        max-height: calc(100vh - 54px);\n      }\n    }\n\n    .CodeMirror {\n      border-color: ", ";\n      border-radius: 8px 8px 0 0 !important;\n      border-bottom: none !important;\n      line-height: 1.5em;\n\n      .cm-header {\n        margin-bottom: 0.5em;\n        display: inline-block;\n        line-height: 1.35em;\n        font-weight: 500;\n        color: ", ";\n      }\n\n      .cm-header-1,\n      .cm-header-2,\n      .cm-header-3 {\n      }\n\n      .cm-header-1 {\n        font-size: 1.5em;\n      }\n\n      .cm-header-2 {\n        font-size: 1.3em;\n      }\n\n      .cm-header-3 {\n        font-size: 1.1em;\n      }\n\n      img {\n        max-width: 100%;\n      }\n    }\n  "])), function (props) {
    return !props._maxWidth && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      max-width: ", ";\n    "], ["\n      max-width: ", ";\n    "])), props._maxWidth);
  }, theme.COLOR('app-chrome'), theme.COLOR('app-chrome'), theme.COLOR('line-subtle'), theme.COLOR('subtle-chrome'), theme.COLOR('line-subtle'), theme.COLOR('line-subtle'), theme.UNIT(2.5), theme.UNIT(1.5), theme.UNIT(1.5), theme.COLOR('app-chrome'), theme.COLOR('strong-chrome'), theme.COLOR('strong-chrome'), theme.COLOR('primary'), theme.COLOR('dark'), theme.COLOR('line-subtle'), theme.COLOR('strong'))
});
var ControlsStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    position: absolute;\n    bottom: ", ";\n    left: ", ";\n  "], ["\n    position: absolute;\n    bottom: ", ";\n    left: ", ";\n  "])), theme.UNIT(2), theme.UNIT(3, 2))
});
var GenerateButtonStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    font-size: ", ";\n    color: ", ";\n    ", ";\n    font-weight: 500;\n    cursor: pointer;\n\n    &:hover {\n      color: ", ";\n      ", ";\n    }\n\n  "], ["\n    font-size: ", ";\n    color: ", ";\n    ", ";\n    font-weight: 500;\n    cursor: pointer;\n\n    &:hover {\n      color: ", ";\n      ", ";\n    }\n\n  "])), theme.FONT_SIZE(13), theme.COLOR('primary'), theme.FILL('primary'), theme.COLOR('dark'), theme.FILL('dark'))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Editor: SimpleMDE,
  Controls: styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ControlsStyles),
  GenerateButton: styled(IconLabel)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), GenerateButtonStyles)
  // ImageModal: styled(EntityModalCreateFormRoute)`${ImageModalStyles}`,
};
export var FormFieldMarkdownEditor = function (props) {
  var className = props.className,
    onChange = props.onChange,
    options = props.options,
    autoFocus = props.autoFocus,
    placeholder = props.placeholder,
    value = props.value,
    name = props.name;
  var dialogs = useDialogs();
  var _a = __read(React.useState(), 2),
    editor = _a[0],
    setEditor = _a[1];
  var t = useLang();
  var toolbar = ['preview', '|', 'bold', 'italic',
  // '|',
  // {
  //   name: 'insert-image-entity',
  //   className: 'fa fa-image',
  //   action: (editor: any) => {
  //     var cm = editor.codemirror;
  //     var output = '';
  //     var selectedText = cm.getSelection();
  //     dialogs.show(
  //       <My.ImageModal 
  //         metadata={{ variant: 'simple' }}
  //         onSubmit={(entity) => {
  //           if (selectedText) {
  //             output = `<${entity.__typename} id="${entity.id}">${selectedText}</${entity.__typename}>`;
  //           } else {
  //             output = `\r\n<${entity.__typename} id="${entity.id}" />\r\n`;
  //           }
  //           cm.replaceSelection(output);
  //           cm.focus();
  //           modal.hide();
  //         }}
  //         onCancel={() => modal.hide()}
  //         definition={entities.ImageAsset}
  //       />
  //     );
  //   }
  // },
  // {
  //   name: `insert-link`,
  //   className: `icon icon-LinkGlyph`, // Look for a suitable icon
  //   action: (editor: any) => {
  //     var cm = editor.codemirror;
  //     var output = '';
  //     var selectedText = cm.getSelection();
  //     dialogs.push(<LinkDialog
  //       text={selectedText}
  //       onCancel={() => {
  //         cm.focus();
  //         modal.hide();
  //       }}
  //       onConfirm={(url: string, text: string) => {
  //         output = `[${text || ''}](${url})`;
  //         cm.replaceSelection(output);
  //         cm.focus();
  //         modal.hide();
  //       }}
  //     />);
  //   },
  //   label: "Link",
  //   title: `Insert Link`,
  // },
  // {
  //   name: `insert-entity`,
  //   className: `icon icon-Entity`, // Look for a suitable icon
  //   action: (editor: any) => {
  //     var cm = editor.codemirror;
  //     var output = '';
  //     var selectedText = cm.getSelection();
  //     modal.show(<EntityEmbedDialog
  //       onCancel={() => {
  //         cm.focus();
  //         modal.hide();
  //       }}
  //       onConfirm={(value: Entity) => {
  //         if (selectedText) {
  //           output = `<${value.__typename} slug="${value.slug}" id="${value.id}">${selectedText}</${value.__typename}>`;
  //         } else {
  //           output = `\n\n<${value.__typename} slug="${value.slug}" id="${value.id}" />\n\n`;
  //         }
  //         cm.replaceSelection(output);
  //         cm.focus();
  //         modal.hide();
  //       }}
  //     />);
  //   },
  //   label: "Embed",
  //   title: `Embed Platform Item`,
  // },
  '|', 'heading-1', 'heading-2', 'heading-3', '|', 'unordered-list', 'ordered-list', 'quote', '|', 'horizontal-rule', '|', 'guide'];
  var handleChange = function (v) {
    onChange({
      value: v
    });
  };
  // const usePlaceholder = valid ? (placeholder || '') : '';
  var opts = __assign(__assign({}, options), {
    placeholder: placeholder,
    autofocus: autoFocus,
    /* @ts-ignore */
    toolbar: toolbar,
    indentWithTabs: false,
    // minHeight: field.minHeight || field.height || options.minHeight,
    syncSideBySidePreviewScroll: false
  });
  var getInstance = function (instance) {
    if (focus) {
      setTimeout(function () {
        if (instance.codemirror && instance.codemirror.focus) {
          instance.codemirror.focus();
        }
      }, 100);
    }
  };
  return React.createElement(My.Container, {
    className: className
  }, React.createElement(My.Editor, {
    getMdeInstance: getInstance,
    id: name,
    onChange: handleChange,
    value: value,
    options: opts
  }));
};
FormFieldMarkdownEditor.cls = cls;
FormFieldMarkdownEditor.defaultProps = FormFieldMarkdownEditorDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;